import React, { useState, useEffect } from 'react'
import { Panel, Row, Col, SelectPicker, Message, Placeholder, Button } from 'rsuite'
import ReactECharts from 'echarts-for-react'
import { CHART_THEME } from '../../constants/project'
import { budgetFormat, numberThousandSeparator } from '../../utils/formatterUtil'
import DashboradToggle from './DashboradToggle'
import { getProjectchart1 } from '../../redux/actions/dashboard'

export default function ProjectChart1({ isSetting, isShow, onSettingChange, dashboradName }) {
  const { Paragraph } = Placeholder
  const [isLoading, setIsLoading] = useState(false)
  const [isError, setIsError] = useState(false)
  const [errorMsg, setErrorMsg] = useState(false)
  const [type, setType] = useState('cluster')

  const [schema, setSchema] = useState()

  useEffect(() => {
    handelGetSchemaDashboard()
  }, [])

  const handelGetSchemaDashboard = async () => {
    setIsLoading(true)
    setIsError(false)
    try {
      let response

      if (isSetting) {
        response = mock
      } else {
        response = mock
        // response = await getProjectchart1()
      }

      setSchema(response)
    } catch (e) {
      setIsError(true)
      setErrorMsg(e.message)
    }
    setIsLoading(false)
  }

  const getDashboardByBudgetYear = async (year) => {
    setIsLoading(true)
    setIsError(false)
    try {
      const response = await getProjectchart1(year)

      setSchema(response)
    } catch (e) {
      setIsError(true)
      setErrorMsg(e.message)
    }
    setIsLoading(false)
  }

  const getBarStackSchema = (schema) => {
    const series = schema.data.map((item) => {
      return {
        name: item.name,
        type: item.type,
        stack: item.group,
        emphasis: {
          focus: 'series',
        },
        data: item.data || [],
      }
    })

    return {
      color: ['#9ffe83', '#3ab294', '#24af5f', '#ffb980', '#d87a80', '#f6e187'],
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow',
        },
      },
      legend: {
        bottom: 0,
        data: schema?.data?.map((item) => item.name) || [],
      },
      toolbox: {
        show: true,
        orient: 'vertical',
        left: 'right',
        top: 'center',
        feature: {
          mark: { show: true },
          dataView: { show: true, readOnly: false },
          magicType: { show: true, type: ['line', 'bar', 'stack', 'tiled'] },
          restore: { show: true },
          saveAsImage: { show: true },
        },
      },
      xAxis: [
        {
          type: 'category',
          axisTick: { show: false },
          data: schema.category,
        },
      ],
      yAxis: [
        {
          type: 'value',
          name: schema.unit,
        },
      ],
      series: series,
    }
  }

  const getGaugeSchema = (schema) => {
    return {
      color: schema.color,
      title: {
        text: schema.title,
        left: 'center',
        bottom: 0,
        textStyle: {
          color: '#575757',
        },
      },
      series: [
        {
          type: 'gauge',
          startAngle: 90,
          endAngle: -270,
          radius: '68%',
          pointer: {
            show: false,
          },
          progress: {
            show: true,
            overlap: true,
            roundCap: true,
            clip: false,
            width: 20,
          },
          axisLine: {
            lineStyle: {
              width: 20,
            },
          },
          splitLine: {
            show: false,
            distance: 0,
            length: 10,
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            show: false,
            distance: 50,
          },
          data: [
            {
              value: schema.projecSubsidies.value,
              name: schema.projecSubsidies.label,
              title: {
                offsetCenter: ['0%', '-10%'],
              },
              detail: {
                valueAnimation: true,
                offsetCenter: ['0%', '10%'],
              },
            },
            {
              value: schema.administrativeBudget.value,
              name: schema.administrativeBudget.label,
              title: {
                offsetCenter: ['0%', '35%'],
              },
              detail: {
                valueAnimation: true,
                offsetCenter: ['0%', '60%'],
              },
            },
          ],
          title: {
            fontSize: 14,
          },
          detail: {
            width: 45,
            height: 10,
            fontSize: 14,
            color: 'auto',
            borderColor: 'auto',
            borderRadius: 20,
            borderWidth: 1,
            formatter: '{value}%',
            // padding: [10, 0, 0, 0],
          },
        },
        {
          type: 'gauge',
          startAngle: 90,
          endAngle: -270,
          max: schema.total.value,
          radius: '80%',
          pointer: {
            show: false,
          },
          progress: {
            show: true,
            overlap: false,
            roundCap: true,
            clip: false,
          },
          axisLine: {
            lineStyle: {
              width: 20,
            },
          },
          splitLine: {
            show: false,
            distance: 0,
            length: 10,
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            show: false,
            distance: 50,
          },
          data: [
            {
              value: schema.total.value,
              name: schema.total.label,
              title: {
                offsetCenter: ['0%', '-50%'],
              },
              detail: {
                valueAnimation: true,
                offsetCenter: ['0%', '-30%'],
              },
            },
          ],
          title: {
            fontSize: 14,
          },
          detail: {
            width: 45,
            height: 10,
            fontSize: 14,
            color: 'auto',
            borderColor: 'auto',
            borderRadius: 20,
            borderWidth: 1,
            formatter: '{value}ลบ.',
            // padding: [10, 0, 0, 0],
          },
        },
      ],
    }
  }

  const getDoughnutSchema = (schema) => {
    const value3 =
      schema.total.value - schema.projecSubsidies.value - schema.administrativeBudget.value

    let label1 = `${schema.projecSubsidies.label} : ${numberThousandSeparator(
      schema.projecSubsidies.value
    )} (${budgetFormat((schema.projecSubsidies.value * 100) / schema.total.value)}%)`
    let label2 = `${schema.administrativeBudget.label} : ${numberThousandSeparator(
      schema.administrativeBudget.value
    )} (${budgetFormat((schema.administrativeBudget.value * 100) / schema.total.value)}%)`
    let label3 = `${schema.total.label} : ${numberThousandSeparator(schema.total.value)} (100%)`

    return {
      color: schema.color,
      title: {
        text: schema.title,
        left: 'center',
        bottom: 0,
        textStyle: {
          color: '#575757',
        },
      },
      tooltip: {
        trigger: 'item',
        formatter: '{b}',
      },
      legend: {
        data: [label1, label2, label3],
      },
      series: [
        {
          name: schema.title,
          type: 'pie',
          radius: ['50%', '70%'],
          // itemStyle: {
          //   borderRadius: 10,
          // },
          label: {
            show: false,
            position: 'center',
          },
          labelLine: {
            show: false,
          },
          emphasis: {
            label: {
              show: true,
            },
          },
          data: [
            {
              value: schema.projecSubsidies.value,
              name: label1,
            },
            {
              value: schema.administrativeBudget.value,
              name: label2,
            },
            {
              value: value3,
              name: label3,
            },
          ],
          title: {
            fontSize: 14,
          },
        },
      ],
    }
  }

  if (!schema) {
    return (
      <Panel shaded bordered defaultExpanded>
        <Paragraph rows={10}></Paragraph>
      </Panel>
    )
  }

  return (
    <Panel header="" bordered collapsible defaultExpanded shaded>
      <Row style={{ marginTop: 10 }}>
        {schema.budgetYear.label}
        <SelectPicker
          data={schema.budgetYear.options}
          defaultValue={schema.budgetYear.value}
          style={{ marginLeft: 10, marginTop: '3px' }}
          searchable={false}
          placeholder="เลือก"
          onChange={(value) => {
            getDashboardByBudgetYear(value)
          }}
        />
      </Row>

      {isError ? (
        <Row style={{ marginTop: 10 }}>
          <Message
            showIcon
            type="error"
            description={
              errorMsg || 'เกิดข้อผิดพลาดในการแสดงข้อมูล กรุณาลองใหม่อีกครั้งหรือติดต่อผู้ดูแลระบบ'
            }
          />
        </Row>
      ) : (
        <Row style={{ marginTop: 10 }}>
          <Col xs={24} sm={12} md={12} lg={6}>
            {isSetting && (
              <DashboradToggle
                onChange={onSettingChange}
                dashboradName={dashboradName}
                checked={isShow}
              />
            )}
            <ReactECharts
              theme={CHART_THEME}
              option={getDoughnutSchema(schema.approve)}
              style={{ height: '400px', width: '100%' }}
              className={'react_for_echarts'}
            />
          </Col>
          <Col xs={24} sm={12} md={12} lg={6}>
            {isSetting && (
              <DashboradToggle
                onChange={onSettingChange}
                dashboradName={dashboradName}
                checked={isShow}
              />
            )}
            <ReactECharts
              theme={CHART_THEME}
              option={getDoughnutSchema(schema.disburse)}
              style={{ height: '400px', width: '100%' }}
              className={'react_for_echarts'}
            />
          </Col>
          <Col xs={24} sm={24} md={24} lg={12} align="right">
            {isSetting && (
              <DashboradToggle
                onChange={onSettingChange}
                dashboradName={dashboradName}
                checked={isShow}
              />
            )}
            <Button
              appearance="ghost"
              color="#2da888"
              style={{
                minWidth: 150,
              }}
              disabled={isLoading}
              onClick={() => {
                if (type == 'cluster') {
                  setType('budgetPlan')
                } else {
                  setType('cluster')
                }
              }}
            >
              {type == 'cluster' ? schema.cluster.label : schema.budgetPlan.label}
            </Button>
            <ReactECharts
              theme={CHART_THEME}
              option={
                type == 'cluster'
                  ? getBarStackSchema(schema.cluster.data)
                  : getBarStackSchema(schema.budgetPlan.data)
              }
              style={{ height: '400px', width: '100%' }}
              className={'react_for_echarts'}
            />
          </Col>
        </Row>
      )}
    </Panel>
  )
}

const mock = {
  budgetYear: {
    name: 'budgetYear',
    value: '2564',
    label: 'ปีงบประมาณ',
    options: [{ label: '2564', value: 2564 }],
  },
  budgetPlan: {
    label: 'แผนงบประมาณ',
    data: {
      unit: '(ล้านบาท)',
      category: ['cluster 1', 'cluster 2', 'cluster 3', 'cluster 4', 'cluster 5'],
      data: [
        {
          name: 'อนุมัติงบอุดหนุนโครงการ',
          group: 'approve',
          type: 'bar',
          data: [8, 10, 7, 5, 9],
        },
        {
          name: 'อนุมัติงบบริหารสำนักงาน',
          group: 'approve',
          type: 'bar',
          data: [10, 11, 9, 5, 4],
        },
        {
          name: 'อนุมัติ',
          group: 'approveLine',
          type: 'line',
          data: [18, 21, 16, 10, 13],
        },
        {
          name: 'เบิกจ่ายอุดหนุนโครงการ',
          group: 'disburse',
          type: 'bar',
          data: [3, 6, 4, 3, 5],
        },
        {
          name: 'เบิกจ่ายบริหารสำนักงาน',
          group: 'disburse',
          type: 'bar',
          data: [8, 8, 8, 4, 3],
        },
        {
          name: 'เบิกจ่าย',
          group: 'disburseLine',
          type: 'line',
          data: [11, 14, 12, 7, 8],
        },
      ],
    },
  },
  cluster: {
    label: 'Cluster',
    data: {
      unit: '(ล้านบาท)',
      category: [
        'แผน 010111',
        'แผน 010112',
        'แผน 010113',
        'แผน 010114',
        'แผน 010115',
        'แผน 010116',
      ],
      data: [
        {
          name: 'อนุมัติงบอุดหนุนโครงการ',
          group: 'approve',
          type: 'bar',
          data: [7, 8, 6, 5, 4, 9],
        },
        {
          name: 'อนุมัติงบบริหารสำนักงาน',
          group: 'approve',
          type: 'bar',
          data: [8, 6, 7, 4, 5, 8],
        },
        {
          name: 'อนุมัติ',
          group: 'approveLine',
          type: 'line',
          data: [15, 13, 13, 9, 9, 17],
        },
        {
          name: 'เบิกจ่ายอุดหนุนโครงการ',
          group: 'disburse',
          type: 'bar',
          data: [6, 5, 6, 3, 4, 7],
        },
        {
          name: 'เบิกจ่ายบริหารสำนักงาน',
          group: 'disburse',
          type: 'bar',
          data: [7, 5, 6, 3, 4, 7],
        },
        {
          name: 'เบิกจ่าย',
          group: 'disburseLine',
          type: 'line',
          data: [13, 10, 12, 6, 8, 14],
        },
      ],
    },
  },
  approve: {
    color: ['#9ffe83', '#3ab294', '#dadde4'],
    title: 'อนุมัติ',
    total: {
      label: 'ทั้งหมด',
      value: 3331100000,
    },
    projecSubsidies: {
      label: 'งบอุดหนุนโครงการ',
      value: 2900000000,
    },
    administrativeBudget: {
      label: 'งบบริหารสำนัก',
      value: 350000000,
    },
  },
  disburse: {
    color: ['#d87a80', '#ffb980', '#dadde4'],
    title: 'เบิกจ่าย',
    total: {
      label: 'ทั้งหมด',
      value: 3526262001,
    },
    projecSubsidies: {
      label: 'งบอุดหนุนโครงการ',
      value: 3000000000,
    },
    administrativeBudget: {
      label: 'งบบริหารสำนัก',
      value: 300000000,
    },
  },
}

const mock2 = {
  budgetYear: {
    options: [
      {
        label: '2564',
        value: 2564,
      },
      {
        label: '2563',
        value: 2563,
      },
    ],
    projectVersionId: null,
    name: 'budgetYear',
    label: 'ปีงบประมาณ',
    value: 2564,
  },
  budgetPlan: {
    label: 'แผนงบประมาณ',
    data: {
      unit: '(ล้านบาท)',
      category: ['Cluster 1', 'Cluster 2', 'Cluster 3', 'Cluster 4', 'Cluster 5'],
      data: [
        {
          name: 'อนุมัติงบอุดหนุนโครงการ',
          group: 'approve',
          type: 'bar',
          data: [10.64, 21, 10.5, 21, 10.5],
        },
        {
          name: 'อนุมัติงบบริหารสำนักงาน',
          group: 'approve',
          type: 'bar',
          data: [21, 21, 21, 21, 21],
        },
        {
          name: 'เบิกจ่ายอุดหนุนโครงการ',
          group: 'disburse',
          type: 'bar',
          data: [21, 21, 21, 21, 21],
        },
        {
          name: 'เบิกจ่ายบริหารสำนักงาน',
          group: 'disburse',
          type: 'bar',
          data: [21, 21, 21, 21, 15],
        },
        {
          name: 'อนุมัติ',
          group: 'approveLine',
          type: 'line',
          data: [31.64, 42, 31.5, 42, 31.5],
        },
        {
          name: 'เบิกจ่าย',
          group: 'disburseLine',
          type: 'line',
          data: [31.64, 42, 31.5, 42, 31.5],
        },
      ],
    },
  },
  cluster: {
    label: 'แผนงบประมาณ',
    data: {
      unit: '(ล้านบาท)',
      category: [
        'แผน 010111',
        'แผน 010112',
        'แผน 010113',
        'แผน 010114',
        'แผน 010115',
        'แผน 010116',
      ],
      data: [
        {
          name: 'อนุมัติงบอุดหนุนโครงการ',
          group: 'approve',
          type: 'bar',
          data: [3.5, 7.11, 10.5, 14.03, 17.5, 21],
        },
        {
          name: 'อนุมัติงบบริหารสำนักงาน',
          group: 'approve',
          type: 'bar',
          data: [5, 10, 15, 20, 25, 30],
        },
        {
          name: 'เบิกจ่ายอุดหนุนโครงการ',
          group: 'disburse',
          type: 'bar',
          data: [5, 10, 15, 20, 25, 30],
        },
        {
          name: 'เบิกจ่ายบริหารสำนักงาน',
          group: 'disburse',
          type: 'bar',
          data: [5, 10, 15, 20, 25, 24],
        },
        {
          name: 'อนุมัติ',
          group: 'approveLine',
          type: 'line',
          data: [8.5, 17.11, 25.5, 34.03, 42.5, 51],
        },
        {
          name: 'เบิกจ่าย',
          group: 'disburseLine',
          type: 'line',
          data: [8.5, 17.11, 25.5, 34.03, 42.5, 51],
        },
      ],
    },
  },
  approve: {
    color: ['#9ffe83', '#3ab294', '#dadde4'],
    title: 'อนุมัติ',
    total: {
      label: 'ทั้งหมด',
      value: 200000000,
    },
    projecSubsidies: {
      label: 'งบอุดหนุนโครงการ',
      value: 73641111,
    },
    administrativeBudget: {
      label: 'งบบริหารสำนัก',
      value: 105000000,
    },
  },
  disburse: {
    color: ['#d87a80', '#ffb980', '#dadde4'],
    title: 'เบิกจ่าย',
    total: {
      label: 'ทั้งหมด',
      value: 250000000,
    },
    projecSubsidies: {
      label: 'งบอุดหนุนโครงการ',
      value: 105000000,
    },
    administrativeBudget: {
      label: 'งบบริหารสำนัก',
      value: 99000000,
    },
  },
}
